"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateCartDataSelector = exports.topSellingProductReducerSelector = exports.topSellingDataSelector = exports.serviceCartDataReducerSelector = exports.serviceCartDataReducerFetchingStateSelector = exports.serviceCartDataReducer = exports.getCartDataSelector = exports.erxCartDataReducerSelector = exports.erxCartDataReducer = exports.cartOperationSelector = exports.cartMarketBannerSelector = exports.cartDataReducerSelector = exports.cartDataReducer = exports.addToCartDataSelector = void 0;
var _reselect = require("reselect");
var _const = require("../../../common/redux/const");
var _const2 = require("./const");
const addToCartReducer = state => state[_const.EPHARMACY_REDUCER][_const2.ADD_TO_CART];
const updateCartReducer = state => state[_const.EPHARMACY_REDUCER][_const2.UPDATE_CART];
const getCartReducer = state => state[_const.EPHARMACY_REDUCER][_const2.GET_CART];
const cartOperationDataReducer = state => state[_const.EPHARMACY_NOT_PERSIST_REDUCER][_const2.CART_OPERATION_DATA];
const topSellingDataReducer = state => state[_const.EPHARMACY_NOT_PERSIST_REDUCER][_const2.TOP_SELLING_PRODUCTS];
const topSellingProductReducer = state => state[_const.EPHARMACY_REDUCER][_const2.TOP_SELLING_PRODUCTS];
const cartMarketBannerReducer = state => state[_const.EPHARMACY_REDUCER][_const2.GET_CART_MARKETING_BANNER];
const cartDataReducer = state => state === null || state === void 0 ? void 0 : state[_const.EPHARMACY_REDUCER][_const2.GET_CART_DETAILS];
exports.cartDataReducer = cartDataReducer;
const erxCartDataReducer = state => state === null || state === void 0 ? void 0 : state[_const.EPHARMACY_REDUCER][_const2.CREATE_RX_CART];
exports.erxCartDataReducer = erxCartDataReducer;
const addToCartDataSelector = () => (0, _reselect.createSelector)(addToCartReducer, addToCartData => {
  var _addToCartData$data;
  return (addToCartData === null || addToCartData === void 0 || (_addToCartData$data = addToCartData.data) === null || _addToCartData$data === void 0 ? void 0 : _addToCartData$data.data) || null;
});
exports.addToCartDataSelector = addToCartDataSelector;
const updateCartDataSelector = () => (0, _reselect.createSelector)(updateCartReducer, updateCartData => {
  var _updateCartData$data;
  return (updateCartData === null || updateCartData === void 0 || (_updateCartData$data = updateCartData.data) === null || _updateCartData$data === void 0 ? void 0 : _updateCartData$data.data) || null;
});
exports.updateCartDataSelector = updateCartDataSelector;
const getCartDataSelector = () => (0, _reselect.createSelector)(getCartReducer, getCartData => {
  var _getCartData$data;
  return (getCartData === null || getCartData === void 0 || (_getCartData$data = getCartData.data) === null || _getCartData$data === void 0 ? void 0 : _getCartData$data.data) || null;
});
exports.getCartDataSelector = getCartDataSelector;
const topSellingProductReducerSelector = () => (0, _reselect.createSelector)(topSellingProductReducer, gettopSellingProductData => {
  var _gettopSellingProduct;
  return (gettopSellingProductData === null || gettopSellingProductData === void 0 || (_gettopSellingProduct = gettopSellingProductData.data) === null || _gettopSellingProduct === void 0 || (_gettopSellingProduct = _gettopSellingProduct.data) === null || _gettopSellingProduct === void 0 ? void 0 : _gettopSellingProduct.productList) || null;
});
exports.topSellingProductReducerSelector = topSellingProductReducerSelector;
const cartOperationSelector = () => (0, _reselect.createSelector)(cartOperationDataReducer, operationReducer => operationReducer || {
  add_to_cart_count: 0,
  update_to_cart_count: 0
});
exports.cartOperationSelector = cartOperationSelector;
const topSellingDataSelector = () => (0, _reselect.createSelector)(topSellingDataReducer, response => {
  var _response$data;
  return (response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 || (_response$data = _response$data.data) === null || _response$data === void 0 ? void 0 : _response$data.productList) || [];
});
exports.topSellingDataSelector = topSellingDataSelector;
const cartMarketBannerSelector = () => (0, _reselect.createSelector)(cartMarketBannerReducer, response => {
  var _response$data2;
  return (response === null || response === void 0 || (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.data) || [];
});
exports.cartMarketBannerSelector = cartMarketBannerSelector;
const cartDataReducerSelector = () => (0, _reselect.createSelector)(cartDataReducer, data => {
  var _data$data;
  return (data === null || data === void 0 || (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.body) || {};
});
exports.cartDataReducerSelector = cartDataReducerSelector;
const erxCartDataReducerSelector = () => (0, _reselect.createSelector)(erxCartDataReducer, data => {
  var _data$data2;
  return (data === null || data === void 0 || (_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.body) || {};
});

/**
 * New Cart Selectors return saved response
 * **/
exports.erxCartDataReducerSelector = erxCartDataReducerSelector;
const serviceCartDataReducer = state => state === null || state === void 0 ? void 0 : state[_const.EPHARMACY_REDUCER][_const2.GET_COMMON_SERVICE_CART_DATA][_const2.MERGE_CART_DETAILS];
exports.serviceCartDataReducer = serviceCartDataReducer;
const serviceCartDataReducerSelector = () => (0, _reselect.createSelector)(serviceCartDataReducer, data => {
  var _data$data3;
  return (data === null || data === void 0 || (_data$data3 = data.data) === null || _data$data3 === void 0 ? void 0 : _data$data3.data) || {};
});
exports.serviceCartDataReducerSelector = serviceCartDataReducerSelector;
const serviceCartDataReducerFetchingStateSelector = () => (0, _reselect.createSelector)(serviceCartDataReducer, data => {
  return (data === null || data === void 0 ? void 0 : data.isFetching) || false;
});
exports.serviceCartDataReducerFetchingStateSelector = serviceCartDataReducerFetchingStateSelector;